import { Result, ok, err } from "neverthrow";
import { ParseError } from "../../shared/errors/parseError";
import {
  HttpQnaInfo,
  HttpQnaListResponse,
  IQnaInfosCollectionParser,
} from "../bbsRepository.types";
import { IQnaInfo, IQnaInfosCollection, QnaInfo } from "@/domain/entities/bbs";
import dayjs from "dayjs";
import { injectable } from "inversify";

export function parseQnaInfo(data: HttpQnaInfo): IQnaInfo {
  const qnaInfoData: IQnaInfo = {
    uid: data.uid,
    serviceUid: data.serviceUid,
    talkBbsCode: data.talkBbsCode,
    talkTypeCode: data.talkTypeCode,
    talkBbsName: data.talkBbsName,
    talkTypeName: data.talkTypeName,
    writerUid: data.writerUid,
    tenantUid: data.tenantUid,
    title: data.title,
    bodyText: data.bodyText,
    readYn: data.readYn,
    secretYn: data.secretYn,
    writerName: data.writerName,
    useBeginDtm: data.useBeginDtm,
    topYn: data.topYn,
    popupYn: data.popupYn,
    displayYn: data.displayYn,
    campusCode: data.metaProps?.campusCode,
    boardLineRoute: data.metaProps?.line,
    boardDtm: data.metaProps?.boardDtm,
    statusCode: data.statusCode,
    statusName: data.talkStatusName,
    qnaTypeCode: data.qnaTypeCode,
    createdTs: dayjs(data.createdTs).format("YYYY-MM-DD HH:mm"),
    savedTs: dayjs(data.savedTs).format("YYYY-MM-DD HH:mm"),
  };
  const qnaInfo = new QnaInfo(qnaInfoData);
  return qnaInfo;
}

@injectable()
export class QnaInfosCollectionParser implements IQnaInfosCollectionParser {
  constructor() {}

  toDomain(
    response: HttpQnaListResponse
  ): Result<IQnaInfosCollection, ParseError> {
    try {
      const totalCount = response.totalCount;
      const qnaInfos = response.data.map(parseQnaInfo);
      const qnaInfosCollection: IQnaInfosCollection = {
        list: qnaInfos,
        totalCount: totalCount ?? 0,
      };
      return ok(qnaInfosCollection);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
